import React, { FunctionComponent } from 'react';
import { Button } from '@mui/material';

interface Props {
  text: any;
  disabled?: boolean;
  variant?: any;
  width?: string;
  height?: string;
  background: string;
  color?: string;
  borderRadius?: string;
  onClick?: (e?: any) => void;
}

export const MyButton: FunctionComponent<Props> = ({
  text,
  disabled,
  width,
  variant,
  height,
  background,
  color,
  borderRadius,
  onClick,
}) => (
  <Button
    onClick={onClick}
    disabled={disabled}
    variant={variant}
    sx={{
      background,
      ':hover': {
        background,
      },
      ':focus': {
        background,
      },
      borderRadius,
    }}
    style={{
      boxShadow: 'none',
      fontFamily: 'sans-serif',
      fontSize: '14px',
      textTransform: 'none',
      width,
      height,
      color,
      background,
      minWidth: '10px',
    }}
    disableRipple
  >
    {text}
  </Button>
);

MyButton.defaultProps = {
  width: '10px',
  disabled: false,
  height: '20px',
  variant: 'contained',
  color: '#FFFFFF',
  borderRadius: '16px',
  onClick: () => undefined,
};
